import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Icon } from '../../../layout/Icon.jsx';

const COLORS = ['#FF7A1A', '#FFB627', '#06B6D4', '#EC4899', '#22C55E', '#8B5CF6', '#0EA5E9', '#EF4444'];

function defaults(c, defaultWarehouseId) {
  return {
    name: c?.name || '',
    color: c?.color || COLORS[0],
    icon: c?.icon || '',
    warehouseId: c?.warehouseId?._id || c?.warehouseId || defaultWarehouseId || '',
    isActive: c?.isActive !== false
  };
}

export function CategoryForm({ open, category, warehouses = [], defaultWarehouseId, onClose, onSubmit, submitting }) {
  const isEdit = !!category;
  const [form, setForm] = useState(defaults(category, defaultWarehouseId));
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setForm(defaults(category, defaultWarehouseId));
      setError('');
    }
  }, [open, category, defaultWarehouseId]);

  if (!open) return null;

  function setField(k, v) {
    setForm((f) => ({ ...f, [k]: v }));
  }

  function handle() {
    if (!form.name?.trim()) { setError('اسم القسم مطلوب'); return; }
    if (!form.warehouseId) { setError('المخزن مطلوب'); return; }
    onSubmit?.({
      name: form.name.trim(),
      color: form.color,
      icon: form.icon || null,
      warehouseId: form.warehouseId,
      isActive: !!form.isActive
    });
  }

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center p-4"
      style={{ background: 'rgba(0,0,0,.45)' }}
    >
      <div className="card w-[440px] max-w-full" onClick={(e) => e.stopPropagation()}>
        <div className="card-h">
          <h3 className="text-[15px] font-bold flex-1">{isEdit ? 'تعديل قسم' : 'قسم جديد'}</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="card-b space-y-3">
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">اسم القسم *</label>
            <input
              className="input"
              value={form.name}
              onChange={(e) => setField('name', e.target.value)}
              placeholder="مثلاً: مشروبات"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">المخزن *</label>
            <select
              className="input"
              value={form.warehouseId}
              onChange={(e) => setField('warehouseId', e.target.value)}
            >
              <option value="">— اختر —</option>
              {warehouses.map((w) => (
                <option key={w._id || w.id} value={w._id || w.id}>{w.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">اللون</label>
            <div className="flex gap-1.5 flex-wrap">
              {COLORS.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setField('color', c)}
                  className={clsx(
                    'w-8 h-8 rounded-full border-2 transition-all',
                    form.color === c ? 'border-ink scale-110' : 'border-transparent'
                  )}
                  style={{ background: c }}
                />
              ))}
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">إيموجي / أيقونة</label>
            <input
              className="input"
              value={form.icon}
              onChange={(e) => setField('icon', e.target.value)}
              placeholder="مثلاً: 🍕"
            />
          </div>
          <label className="flex items-center gap-2 cursor-pointer text-[13px] text-ink-2">
            <input
              type="checkbox"
              className="accent-orange"
              checked={form.isActive}
              onChange={(e) => setField('isActive', e.target.checked)}
            />
            فعّال
          </label>
          {error ? <div className="text-red text-[12px] font-semibold">{error}</div> : null}
        </div>
        <div className="card-h border-b-0 border-t flex justify-end gap-2">
          <button type="button" className="btn" onClick={onClose} disabled={submitting}>إلغاء</button>
          <button type="button" className="btn btn-primary" onClick={handle} disabled={submitting}>
            {submitting ? 'جاري الحفظ...' : isEdit ? 'حفظ' : 'إنشاء القسم'}
          </button>
        </div>
      </div>
    </div>
  );
}
